// 判断时间范围是否在72小时内
export const isWithin72Hours = (startTime, endTime) => {
  if (startTime && endTime) {
    // 确保输入是Date对象
    const start = new Date(startTime);
    const end = new Date(endTime);

    // 验证时间有效性
    if (isNaN(start.getTime())) {
      throw new Error('无效的开始时间');
    }
    if (isNaN(end.getTime())) {
      throw new Error('无效的结束时间');
    }

    // 确保结束时间不早于开始时间
    if (end < start) {
      throw new Error('结束时间不能早于开始时间');
    }

    // 计算时间差（毫秒）
    const diffInMs = end - start;

    // 72小时的毫秒数 = 72 * 60 * 60 * 1000
    const seventyTwoHoursInMs = 72 * 60 * 60 * 1000;

    // 判断是否在72小时内（包含等于72小时）
    return diffInMs <= seventyTwoHoursInMs;
  } else {
    return false
  }


}

// 格式化时间
export const formatDate = (...times) => {
  return times.map(time => {
    // 创建Date对象
    const date = new Date(time);

    // 验证时间有效性
    if (isNaN(date.getTime())) {
      throw new Error(`无效的时间参数: ${time}`);
    }

    // 获取各个时间部分
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    // 组合成'年-月-日 时:分:秒'格式
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  });
}

/**
 * 将时间戳转换为格式化的日期时间字符串
 * @param {number} startTimestamp 开始时间戳（毫秒）
 * @param {number} endTimestamp 结束时间戳（毫秒）
 * @returns {Object} 包含格式化后的开始和结束时间对象
 */
export function formatTimestamps(startTimestamp, endTimestamp) {
  // 统一转换为数字类型的时间戳
  const parseTimestamp = (timestamp) => {
    if (typeof timestamp === 'string') {
      // 如果是字符串，尝试转换为数字
      const parsed = Number(timestamp);
      return isNaN(parsed) ? NaN : parsed;
    } else if (typeof timestamp === 'number') {
      return timestamp;
    }
    return NaN;
  };

  const start = parseTimestamp(startTimestamp);
  const end = parseTimestamp(endTimestamp);

  // 验证时间戳有效性
  if (isNaN(start)) throw new Error('无效的开始时间戳');
  if (isNaN(end)) throw new Error('无效的结束时间戳');
  if (start > end) throw new Error('开始时间不能晚于结束时间');

  // 格式化日期时间
  const formatDateTime = (timestamp) => {
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) return '无效日期';

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  return {
    startTime: formatDateTime(start),
    endTime: formatDateTime(end)
  };
}